// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/images/cv-pro-competition-kit/CVProTopBanner.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../public/images/cv-pro-competition-kit/CV-Pro-competitionkit-mob-banner.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cpck-banner-top {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: contain;
  height: 28.1vw;
  width: 100%;
}

.cpck-banner-content-wrapper {
  position: absolute;
  top: 50%;
  left: 20%;
  transform: translate(-10%, 10%);
}

.cpck-banner-content-wrapper p {
}

.cpck-banner-content-wrapper img {
  height: 80px;
  width: auto;
  margin-left: -15px;
}

.cpck-banner-content-wrapper h1 {
  color: #29a8cf;
  text-transform: capitalize;
  font-weight: 600;
}

.cpck-banner-text-btn-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.cvpc-banner-btn {
  border-radius: 20px;
  padding: 5px 20px;
  background-color: #02cd78;
  border: medium none currentColor;
  border: initial;
  font-weight: 600;
}

.cvpc-sub-head p {
  color: #27ace3;
  font-size: 25px;
  font-weight: 600;
  padding-bottom: 40px;
}

/* Meet CV Pro  */
.about-cvpro-content-wrapper {
  padding: 0 10%;
}
.about-cvpro-txt p {
  padding-bottom: 20px;
}

.about-cvpro-txt p span {
  color: #0a4eab;
  font-weight: 500;
}

/* What is in the box */
.cvpro-box {
  background-color: #f5f6fb;
}

.cvpro-box-img {
  padding: 0 5%;
}

/* Code | Train | Drive | Navigate */
.ctdn-heading h2 {
  color: #000 !important;
  font-weight: 500;
}
.purple-text {
  color: #bb5da2 !important;
  font-weight: 700;
}

.blue-text {
  color: #458bc6 !important;
  font-weight: 700;
}

.orange-text {
  color: #ec812a !important;
  font-weight: 700;
}

.green-text {
  color: #8cba58 !important;
  font-weight: 700;
}

.sub-heading-npgs p span {
  font-weight: 900;
}

/* technology icons  */
.cvpc-tech-icons {
  display: flex;
  align-content: center;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  padding: 0 10%;
}

.cvpc-tech-icons img {
  height: 85px;
  width: auto;
  margin: 15px 30px;
}

.deeplearn-img {
  height: 70px !important;
}

/* CV Pro product image slider  */
/* .cv-pro-slider .owl-stage-outer .owl-stage .owl-item .active {
  width: 350px;
  height: auto;
} */

.cv-pro-slider .owl-stage-outer .owl-stage .owl-item {
  display: flex;
  align-items: center;
  justify-content: center;
}

.cv-pro-slider .owl-stage-outer .owl-stage {
  display: flex;
}

.cv-pro-slider .owl-stage-outer .owl-stage .owl-item .cv-pro-kit-img img {
  height: 325px;
  width: auto;
}

.cv-pro-slider .owl-stage-outer .owl-stage .center .cv-pro-kit-img img {
  height: 450px;
  width: auto;
}

.cv-pro-slider .owl-nav button.owl-prev {
  position: absolute;
  top: 13%;
  left: -5%;
  font-size: 80px;
  background-color: #27aae0;
  color: #fff;
  height: 325px;
  width: 70px;
}

.cv-pro-slider .owl-nav button.owl-next {
  position: absolute;
  top: 13%;
  right: -5%;
  font-size: 80px;
  background-color: #27aae0;
  color: #fff;
  height: 325px;
  width: 70px;
}

.cv-pro-slider .owl-nav [class*="owl-"]:hover {
  background-color: #27aae0;
  color: #fff;
  text-decoration: none;
}

@media (max-width: 1024px) {
  .cpck-banner-content-wrapper img {
    height: 50px;
    margin-left: -5px;
  }

  .cpck-banner-content-wrapper {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-100%, 0%);
  }

  .cpck-banner-content-wrapper h1 {
    font-size: 18px;
    padding-bottom: 0px;
  }

  .cpck-banner-content-wrapper p {
    margin-bottom: 0px;
    line-height: 1.3;
  }

  .cvpc-sub-head p {
    padding-bottom: 0px;
  }

  .about-cvpro-txt p {
    padding-bottom: 0px;
  }

  .cvpc-tech-icons {
    padding: 0;
    padding: initial;
    justify-content: space-between;
  }

  .cvpc-tech-icons img {
    height: 75px;
    margin: 15px 5px;
  }

  .deeplearn-img {
    height: 50px !important;
  }

  .wro-video {
    padding: 10%;
  }
}

@media (max-width: 576px) {
  .cpck-banner-top {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-repeat: no-repeat;
    background-size: contain;
    height: 127.1vw;
    width: 100%;
  }

  .d-none-mob {
    display: none;
  }

  .cpck-banner-content-wrapper {
    position: absolute;
    top: 70%;
    left: 30%;
    transform: translate(-50%, -50%);
  }

  .mob-position {
    position: static !important;
    position: initial !important;
  }

  .cv-pro-slider .owl-stage-outer .owl-stage .owl-item .cv-pro-kit-img img {
    height: 150px;
    width: auto;
  }
  .cv-pro-slider .owl-stage-outer .owl-stage .center .cv-pro-kit-img img {
    height: 250px;
    width: auto;
  }

  .cv-pro-slider .owl-nav button.owl-prev {
    top: -2%;
    left: 0%;
    font-size: 60px;
    height: 250px;
    width: 50px;
  }

  .cv-pro-slider .owl-nav button.owl-next {
    top: -2%;
    right: 0%;
    font-size: 60px;
    height: 250px;
    width: 50px;
  }

  .deeplearn-img {
    height: 45px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/indivdual-product-pages/CV Pro Competion Kit/CVProCompetitonKit.css"],"names":[],"mappings":"AAAA;EACE,yDAA4F;EAC5F,4BAA4B;EAC5B,wBAAwB;EACxB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,+BAA+B;AACjC;;AAEA;AACA;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,gCAAa;EAAb,eAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,iBAAiB;AACjB;EACE,cAAc;AAChB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA,oCAAoC;AACpC;EACE,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,iCAAiC;AACjC;;;GAGG;;AAEH;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,+BAA+B;EACjC;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,UAAc;IAAd,gBAAc;IACd,8BAA8B;EAChC;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,yDAA8G;IAC9G,4BAA4B;IAC5B,wBAAwB;IACxB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;EAClC;;EAEA;IACE,2BAA0B;IAA1B,4BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,WAAW;EACb;EACA;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,QAAQ;IACR,QAAQ;IACR,eAAe;IACf,aAAa;IACb,WAAW;EACb;;EAEA;IACE,QAAQ;IACR,SAAS;IACT,eAAe;IACf,aAAa;IACb,WAAW;EACb;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".cpck-banner-top {\n  background-image: url(\"../../../../public/images/cv-pro-competition-kit/CVProTopBanner.png\");\n  background-repeat: no-repeat;\n  background-size: contain;\n  height: 28.1vw;\n  width: 100%;\n}\n\n.cpck-banner-content-wrapper {\n  position: absolute;\n  top: 50%;\n  left: 20%;\n  transform: translate(-10%, 10%);\n}\n\n.cpck-banner-content-wrapper p {\n}\n\n.cpck-banner-content-wrapper img {\n  height: 80px;\n  width: auto;\n  margin-left: -15px;\n}\n\n.cpck-banner-content-wrapper h1 {\n  color: #29a8cf;\n  text-transform: capitalize;\n  font-weight: 600;\n}\n\n.cpck-banner-text-btn-wrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.cvpc-banner-btn {\n  border-radius: 20px;\n  padding: 5px 20px;\n  background-color: #02cd78;\n  border: unset;\n  font-weight: 600;\n}\n\n.cvpc-sub-head p {\n  color: #27ace3;\n  font-size: 25px;\n  font-weight: 600;\n  padding-bottom: 40px;\n}\n\n/* Meet CV Pro  */\n.about-cvpro-content-wrapper {\n  padding: 0 10%;\n}\n.about-cvpro-txt p {\n  padding-bottom: 20px;\n}\n\n.about-cvpro-txt p span {\n  color: #0a4eab;\n  font-weight: 500;\n}\n\n/* What is in the box */\n.cvpro-box {\n  background-color: #f5f6fb;\n}\n\n.cvpro-box-img {\n  padding: 0 5%;\n}\n\n/* Code | Train | Drive | Navigate */\n.ctdn-heading h2 {\n  color: #000 !important;\n  font-weight: 500;\n}\n.purple-text {\n  color: #bb5da2 !important;\n  font-weight: 700;\n}\n\n.blue-text {\n  color: #458bc6 !important;\n  font-weight: 700;\n}\n\n.orange-text {\n  color: #ec812a !important;\n  font-weight: 700;\n}\n\n.green-text {\n  color: #8cba58 !important;\n  font-weight: 700;\n}\n\n.sub-heading-npgs p span {\n  font-weight: 900;\n}\n\n/* technology icons  */\n.cvpc-tech-icons {\n  display: flex;\n  align-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n  justify-content: center;\n  padding: 0 10%;\n}\n\n.cvpc-tech-icons img {\n  height: 85px;\n  width: auto;\n  margin: 15px 30px;\n}\n\n.deeplearn-img {\n  height: 70px !important;\n}\n\n/* CV Pro product image slider  */\n/* .cv-pro-slider .owl-stage-outer .owl-stage .owl-item .active {\n  width: 350px;\n  height: auto;\n} */\n\n.cv-pro-slider .owl-stage-outer .owl-stage .owl-item {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.cv-pro-slider .owl-stage-outer .owl-stage {\n  display: flex;\n}\n\n.cv-pro-slider .owl-stage-outer .owl-stage .owl-item .cv-pro-kit-img img {\n  height: 325px;\n  width: auto;\n}\n\n.cv-pro-slider .owl-stage-outer .owl-stage .center .cv-pro-kit-img img {\n  height: 450px;\n  width: auto;\n}\n\n.cv-pro-slider .owl-nav button.owl-prev {\n  position: absolute;\n  top: 13%;\n  left: -5%;\n  font-size: 80px;\n  background-color: #27aae0;\n  color: #fff;\n  height: 325px;\n  width: 70px;\n}\n\n.cv-pro-slider .owl-nav button.owl-next {\n  position: absolute;\n  top: 13%;\n  right: -5%;\n  font-size: 80px;\n  background-color: #27aae0;\n  color: #fff;\n  height: 325px;\n  width: 70px;\n}\n\n.cv-pro-slider .owl-nav [class*=\"owl-\"]:hover {\n  background-color: #27aae0;\n  color: #fff;\n  text-decoration: none;\n}\n\n@media (max-width: 1024px) {\n  .cpck-banner-content-wrapper img {\n    height: 50px;\n    margin-left: -5px;\n  }\n\n  .cpck-banner-content-wrapper {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-100%, 0%);\n  }\n\n  .cpck-banner-content-wrapper h1 {\n    font-size: 18px;\n    padding-bottom: 0px;\n  }\n\n  .cpck-banner-content-wrapper p {\n    margin-bottom: 0px;\n    line-height: 1.3;\n  }\n\n  .cvpc-sub-head p {\n    padding-bottom: 0px;\n  }\n\n  .about-cvpro-txt p {\n    padding-bottom: 0px;\n  }\n\n  .cvpc-tech-icons {\n    padding: unset;\n    justify-content: space-between;\n  }\n\n  .cvpc-tech-icons img {\n    height: 75px;\n    margin: 15px 5px;\n  }\n\n  .deeplearn-img {\n    height: 50px !important;\n  }\n\n  .wro-video {\n    padding: 10%;\n  }\n}\n\n@media (max-width: 576px) {\n  .cpck-banner-top {\n    background-image: url(\"../../../../public/images/cv-pro-competition-kit/CV-Pro-competitionkit-mob-banner.jpg\");\n    background-repeat: no-repeat;\n    background-size: contain;\n    height: 127.1vw;\n    width: 100%;\n  }\n\n  .d-none-mob {\n    display: none;\n  }\n\n  .cpck-banner-content-wrapper {\n    position: absolute;\n    top: 70%;\n    left: 30%;\n    transform: translate(-50%, -50%);\n  }\n\n  .mob-position {\n    position: unset !important;\n  }\n\n  .cv-pro-slider .owl-stage-outer .owl-stage .owl-item .cv-pro-kit-img img {\n    height: 150px;\n    width: auto;\n  }\n  .cv-pro-slider .owl-stage-outer .owl-stage .center .cv-pro-kit-img img {\n    height: 250px;\n    width: auto;\n  }\n\n  .cv-pro-slider .owl-nav button.owl-prev {\n    top: -2%;\n    left: 0%;\n    font-size: 60px;\n    height: 250px;\n    width: 50px;\n  }\n\n  .cv-pro-slider .owl-nav button.owl-next {\n    top: -2%;\n    right: 0%;\n    font-size: 60px;\n    height: 250px;\n    width: 50px;\n  }\n\n  .deeplearn-img {\n    height: 45px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
